import React, { useEffect, useRef,useContext } from 'react';
import { Grid, Typography, Card } from '@material-ui/core';
import { PushToTalkButton, PushToTalkButtonContainer, ErrorPanel } from '@speechly/react-ui';
import Details from './components/Details'; 
import Main from './components/Main/Main';
import { SpeechState, useSpeechContext } from '@speechly/react-client';
import { ExpenseTrackerContext } from './context/context';
import {  CardHeader, Tooltip} from '@material-ui/core';
import List from './components/Main/List/List';
import InfoCard from './components/InfoCard';
import Form from './components/Main/Form/Form';
import speech from './assets/speech.jpg'
import  './styles';
// import Tooltip from '@mui/material/Tooltip';

const App = () => {
    // const classes = useStyles();
    const { speechState } = useSpeechContext();
    const { balance } = useContext(ExpenseTrackerContext);
    const main = useRef(null);

    const executeScroll = () => main.current.scrollIntoView();

    useEffect(() => {
        if(speechState === SpeechState.Recording) {
            executeScroll();
        }
    
    }, [speechState]);

    return (
        <>
            <div className="header">
                <h1>Simple,voice enabled </h1>
                <p>income/expense report tool.</p>
            </div>
            <div className="navbar">
                <InfoCard/>
            </div>
            <div class="row">
                <div class="side">
                    <h2>Details</h2>
                    <h5>Details of me Income:</h5>
                    <Details title="Income"/>
                    <p>Apply with react-chartjs-2</p>
                    <h3>Details of me Expense:</h3>
                    <Details title="Expense"/>
                    <p>Apply with react-chartjs-2</p>
                </div>
                <div class="main">
                    <h2>FORM</h2>
                    <h5>Enter a new record</h5>
                    <Form/>
                    <p>You need to get approval after creating a record..</p>
                    <Typography align="center" variant="h5" style={{backgroundColor: 'black', color: 'white', opacity: '0.8', padding: '10px'}} >Total Balance ${balance}</Typography>
                    <h2>LIST</h2>
                    <h5>You can track and delete records from your list</h5>
                    <List/>
                    <p>Some text..</p>
                    <p>Sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                </div>
            </div>
            <PushToTalkButtonContainer>
                <PushToTalkButton />
                <ErrorPanel/>
            </PushToTalkButtonContainer>
            <div class="footer">
                <h2>Footer</h2>
            </div>
            
        </>
        
        );
    }

export default App;

{/* <Grid container spacing={0} alignItems="center" justify="center" style={{ height: '100vh' }}>
                <Card>
                <CardHeader title="Tracking The Money" subheader="Powered by Speechly" /> 
                </Card>
                <Card>
                    <Typography align="center" variant="h5" >Total Balance ${balance}</Typography>
                </Card>
                <Typography variant="subtitle1" style={{ lineHeight: '1.0em', marginTop: '20px' }}>
                   <InfoCard />
                </Typography> 
                <Grid item xs={12} sm={4} >
                    <Details title="Income"/>
                </Grid>
                <Card item  xs={12} sm={3} >
                    <Form/>
                </Card >
                <Grid item  xs={6} sm={4} >
                    <List />
                </Grid>
                <Grid style={{display: 'flex'}} >
                <Grid item xs={6} sm={4} >
                    <Details title="Income"/>
                </Grid>    
                <Grid item xs={6} sm={4} >
                    <Details title="Expense"/>
                </Grid>
                </Grid>
            </Grid> */}





{/* <div className='button1 col-4' >
                    <PushToTalkButton  /> 
                    <ErrorPanel />
            </div> */}

{/* <div className='wrapper'> 
            <CardHeader className='header' variant="h3" title="Simple,voice enabled, income/expense report tool"  />
            <div className='container row ' style={{display: 'flex'}}  > 
                    <div className='popup  mt-5 '>
                        <span className='col-7 popuptext'>Try seying income categories 100$ Business</span>
                    </div>
                <div  className='col-5 form' >
                        <PushToTalkButton /> 
                        <ErrorPanel />
                </div>  
            </div>
            <Grid xs={12} sm={7}  className="list">
                <Card>
                    <Form/>
                </Card>
            </Grid>
            <Grid className='list ' xs={12} sm={7}>
                <List/>
            </Grid>
            <Card className="total" >
                <Typography  variant="h5" >Total Balance ${balance}</Typography>
            </Card>
            <div class="container row justify-content-evenly mt-5">
                <div class="col-6">
                    <Details title="Income"/>
                </div>
                <div class="col-6">
                    <Details title="Expense"/>
                </div>
            </div>
        
                
            
            
            
        </div> */}
